module.exports = __webpack_public_path__ + "static/media/backpack.695a2824.png";